import type { ReactNode } from "react";

interface ProjectSectionProps {
  title: string;
  children: ReactNode;
}

/** Applies consistent semantic structure to a project-detail evidence section. */
export default function ProjectSection({
  title,
  children,
}: ProjectSectionProps) {
  return (
    <section className="project-section">
      <h2>{title}</h2>
      {children}
    </section>
  );
}
